module.exports = __webpack_public_path__ + "static/media/PhoneCall.4b7e8f1d.svg";